import {
  BlueBirdTheme,
  Button, CrossIcon, Form, Typography,
} from "@kitbird/core";
import { PropsWithChildren, useRef, useState } from "react";
import PdfLogo from "../../../../../assets/icons/pdf_file.svg";
import imgIcon from "../../../../../assets/icons/img_icon.svg";
import trashIcon from "../../../../../assets/icons/trash_Icon.svg";
import conditionalArrow from "../../../../../assets/icons/conditional_arrow.svg";
import {
  FormGroup,
  FormWrapper,
} from "../../../../../components/Form/Form.style";
import {
  UploadSection,
  WrapperContainerForm,
  WrapperIcon,
  WrapperIconDesc,
  WrapperInput,
  WrapperLabel,
  WrapperUpload,
} from "./MultipleUpload.style";
import { UploadMediaI } from "../../../../../typings/common";
import UseMultiUpload from "./useMultiUpload";

interface ListFileUpload extends PropsWithChildren {
  onFileBrowse: (event: any | null) => void;
  doDeleteFileIndex: (file: any) => void;
  listFile: UploadMediaI[];
  accept?: string;
}

const { gray } = BlueBirdTheme.colors;

const MultipleUpload = ({
  onFileBrowse, doDeleteFileIndex, listFile, accept,
}: ListFileUpload) => {
  const {
    handleButtonClick,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    dragging,
    fileInputRef,
  } = UseMultiUpload({ onFileBrowse });

  return (
    <>
      <FormGroup>
        <FormWrapper>
          <WrapperContainerForm
            onDragEnter={handleDragEnter}
            $drag={dragging}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <WrapperIconDesc>
              <img src={conditionalArrow} />
              <span
                style={{
                  fontWeight: "500",
                  alignSelf: "center",
                  width: "100%",
                }}
              >
                Seret atau pilih file untuk upload
              </span>
            </WrapperIconDesc>
            <Button
              style={{ padding: "0 18px" }}
              size="sm"
              onClick={handleButtonClick}
            >
              Pilih file
            </Button>
          </WrapperContainerForm>
          <input
            type="file"
            ref={fileInputRef}
            onChange={(e) => {
              onFileBrowse(e.target.files);
            }}
            style={{ display: "none" }}
            accept={accept}
          />
          <Typography level={6} fontWeight="regular" color={gray.disable}>
            Ukuran file maksimal&nbsp;
            <Typography level={6} fontWeight="bold" color={gray.disable}>
              10 MB&nbsp;
            </Typography>
            (mendukung format .JPG, .JPEG, .PNG, .PDF)
          </Typography>
        </FormWrapper>
      </FormGroup>

      <FormGroup>
        {listFile.length > 0 && (
          <UploadSection>
            {listFile?.map((file, i) => (
              <WrapperInput key={`${file.FileName}-${i}`}>
                <WrapperUpload>
                  <img
                    style={{ alignSelf: "flex-start" }}
                    src={file?.FileType?.includes("pdf") ? PdfLogo : imgIcon}
                  />
                  <WrapperLabel>
                    <div className="ellipsis-text">
                      <Typography fontWeight="bold" level={6}>
                        {file.FileName}
                      </Typography>
                    </div>
                    <Typography color="#888888" level={7}>
                      <span style={{ fontWeight: 700 }}>{file.FileSizeString}</span>
                    </Typography>
                  </WrapperLabel>
                  <WrapperIcon>
                    <img
                      style={{ cursor: "pointer" }}
                      onClick={() => doDeleteFileIndex(i)}
                      src={trashIcon}
                    />
                  </WrapperIcon>
                </WrapperUpload>
              </WrapperInput>
            ))}
          </UploadSection>
        )}
      </FormGroup>
    </>
  );
};

export default MultipleUpload;
